<template>
  <div>
    <div class="ariticle-title">
      <span>金融市场</span>
    </div>
    <div class="ariticle-subtitle">
      <span>2021 年 2 月 11 日更新</span>
      <span></span>
    </div>
    <div class="ariticle-content">
      <p><b>什么金融市场？</b></p>
      <p>
      金融市场泛指进行证券交易的任何市场，包括股票市场、债券市场、外汇市场和衍生品市场等。
      </p>
      <br>
      <img src='/imgs/financialmarkets.png'/>
      <br>
      <br>
      <p><b>股市</b></p>
      <p>
      最普遍的金融市场是股票市场。这些是公司上市股票并由交易员和投资者买卖的场所。公司利用股票市场或股票市场通过首次公开募股 (IPO) 筹集资金，随后股票在所谓的二级市场上在各种买卖双方之间进行交易。
      </p>
      <br>
      <p><b>场外交易市场</b></p>
      <p>
      场外交易 (OTC) 市场是一个去中心化的市场——这意味着它没有实体位置，交易以电子方式进行——市场参与者在没有经纪人的情况下直接在两方之间交易证券。虽然场外交易市场可以处理某些股票的交易（例如，不符合交易所上市标准的较小或风险较高的公司），但大多数股票交易是通过交易所进行的。然而，某些衍生品市场完全是场外交易，因此构成了金融市场的重要部分。从广义上讲，场外交易市场及其上发生的交易受到的监管要少得多，流动性更差，而且更不透明。
      </p>
      <br>
      <p><b>债券市场</b></p>
      <p>
      债券是一种证券，投资者在规定的期限内以预先设定的利率贷款。您可能会将债券视为贷方和借方之间的协议，其中包含贷款及其付款的详细信息。债券由公司以及市政当局、州和主权政府发行，以资助项目和运营。
      </p>
      <br>
      <p><b>货币市场</b></p>
      <p>
      通常，货币市场交易的产品具有高流动性的短期到期（少于一年），其特点是安全性高，利息回报率相对较低。在批发层面，货币市场涉及机构和交易者之间的大宗交易。在零售层面，它们包括个人投资者购买的货币市场共同基金和银行客户开设的货币市场账户。个人还可以通过购买短期存款证(CD)、 市政票据或美国国库券等方式投资于货币市场。
      </p>
      <br>
      <p><b>衍生品市场</b></p>
      <p>
      衍生品是两方或多方之间的合同，其价值基于商定的基础金融资产（如证券）或一组资产（如指数）。衍生品是二级证券，其价值完全来自与其相关的一级证券的价值。衍生品本身是毫无价值的。衍生品市场不是直接交易股票，而是交易期货和期权合约以及其他高级金融产品，这些产品的价值来自债券、商品、货币、利率、市场指数和股票等基础工具。 
      </p>
      <br>
      <p><b>期货市场</b></p>
      <p>
      期货市场是期货合约上市和交易的地方。与在场外交易的远期交易不同，期货市场使用标准化的合约规范，受到良好监管，并利用票据交换所来结算和确认交易。期权市场，例如芝加哥期权交易所(CBOE)，同样列出和监管期权合约。期货和期权交易所都可以列出各种资产类别的合约，例如股票、固定收益证券、商品等。
      </p>
      <br>
      <p><b>外汇市场</b></p>
      <p>
      外汇（外汇）市场是参与者可以对货币对之间的汇率进行买卖、对冲和投机的市场。外汇市场是世界上流动性最强的市场，因为现金是最具流动性的资产。货币市场每天处理超过 5 万亿美元的交易，比期货和股票市场的总和还要多。与场外交易市场一样，外汇市场也是分散的，由来自世界各地的计算机和经纪人组成的全球网络。外汇市场由银行、商业公司、中央银行、投资管理公司、对冲基金、零售外汇经纪商和投资者组成。 
      </p>
      <br>
      <p><b>商品市场</b></p>
      <p>
      商品市场是生产者和消费者会面以交换实物商品的场所，例如农产品（例如玉米、牲畜、大豆）、能源产品（石油、天然气、碳信用）、贵金属（黄金、白银、铂金）或“软商品（如棉花、咖啡和糖）。这些被称为现货商品市场，其中实物商品被兑换成货币。
      </p>
      <br>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
</style>
